import { LANGUAGE_LEVELS, LANGUAGE_LEVELS_REVERSED, REQUIREMENT_TYPE } from "./Profile.constants";

export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const updateProfileArrays = ({ profile, index, updatedRequirement, filteredSkills }) => {
  const update = {
    requirements: profile.requirements,
    chatbotQuestions: profile.chatbotQuestions || []
  };

  update.requirements = update.requirements.map((req, i) =>
    i === index ? updatedRequirement : req
  );

  if (updatedRequirement.isAutomated) {
    const existingQuestionIndex = update.chatbotQuestions.findIndex(
      (question) => question.name === updatedRequirement.category
    );

    if (existingQuestionIndex !== -1) {
      // Update the existing question
      update.chatbotQuestions = update.chatbotQuestions.map((question) =>
        question.name === updatedRequirement.category
          ? mapRequirementToChatbotQuestion(updatedRequirement, filteredSkills)
          : question
      );
    } else {
      // Add a new question
      update.chatbotQuestions = [
        ...update.chatbotQuestions,
        mapRequirementToChatbotQuestion(updatedRequirement, filteredSkills)
      ];
    }
  }

  return update;
};

export const mapRequirementToChatbotQuestion = (requirement, filteredSkills) => {
  const screeningQuestionId = generateUUID();

  const baseQuestion = {
    screeningQuestionId: screeningQuestionId,
    name: requirement.category,
    deliveryMethod: requirement.deliveryMethod,
    isActive: true
  };

  switch (requirement.type) {
    case "weightedOptions":
      return {
        ...baseQuestion,
        type: REQUIREMENT_TYPE.WEIGHTED_OPTION,
        options: filteredSkills.map((skillName) => {
          // Find the matching option in requirement.options by name
          const matched = requirement.options.find((r) => r.name === skillName);
          const weight = matched && typeof matched.weight === "number" ? matched.weight + 1 : 0;

          return {
            name: skillName,
            weight,
            isSelected: true
          };
        })
      };

    case "list":
    default:
      return {
        ...baseQuestion,
        type: REQUIREMENT_TYPE.LIST,
        options: filteredSkills.map((skillName) => ({
          name: skillName,
          isSelected: true
        }))
      };
  }
};

export const getFilteredSkills = (requirementCategory, domainSkills) => {
  if (!requirementCategory || !domainSkills.length) return [];

  return domainSkills
    .filter(({ category }) => category === requirementCategory)
    .map(({ name }) => name);
};

export const getLanguageLevel = () => Object.values(LANGUAGE_LEVELS);

export const saveLanguage = (weight, category) => {
  if (category === "languages") {
    return LANGUAGE_LEVELS_REVERSED[weight];
  }
  return weight;
};

export const getNumericWeight = (weight, category) => {
  if (category === "languages") {
    const languageMap = {
      A1: 0,
      A2: 1,
      B1: 2,
      B2: 3,
      C1: 4,
      C2: 5
    };
    return languageMap[weight] || 0;
  }
  return weight;
};

export const requirementNeedsConfiguration = (requirement) => {
  if (requirement.importance === null) {
    return true;
  }

  if (requirement.type === "weightedOptions") {
    return requirement.options.every((option) => option.weight === 0);
  }

  if (requirement.type === "list") {
    return !requirement.options || requirement.options.length === 0;
  }

  return false;
};

export const toggleListOption = (item, array) => {
  const index = array.findIndex((el) => el.name === item);
  if (index === -1) {
    return [...array, { name: item }];
  } else {
    return array.filter((_el, i) => i !== index);
  }
};
